import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import { Dashboard } from "./routes/Dashboard";
import { Cli } from "./routes/Cli";
import { loginUrl } from "./lib/urls";
import { captureSignupIntent } from "./lib/intent";
import { ConsentBanner, PostHogUser } from "./analytics";
import "./styles.css";
import "./design/components.css";
import { applyTheme } from "./design/theme";

applyTheme();
captureSignupIntent();

const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as
  | string
  | undefined;

if (!CLERK_PUBLISHABLE_KEY) {
  document.body.innerHTML =
    '<div style="padding:32px;color:var(--ds-bad)">Missing VITE_CLERK_PUBLISHABLE_KEY at build time.</div>';
  throw new Error("missing VITE_CLERK_PUBLISHABLE_KEY");
}

function App() {
  return window.location.pathname.startsWith("/cli") ? <Cli /> : <Dashboard />;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={CLERK_PUBLISHABLE_KEY}
      signInUrl={`${loginUrl()}/sign-in`}
      signUpUrl={`${loginUrl()}/sign-up`}
    >
      <App />
      <PostHogUser />
      <ConsentBanner />
    </ClerkProvider>
  </React.StrictMode>,
);
